import React from "react";

export default function PageHeading({className, heading, description}) {

    return (
        <section className={`pb-0 top-space-padding page-title-center-alignment ${className}`}>
            <div className="container">
                <div className="row align-items-center justify-content-center extra-very-small-screen">
                    <div
                        className="col-xl-10 col-lg-10 text-center position-relative page-title-extra-large"
                        data-anime='{ "el": "childs", "translateY": [-15, 0], "opacity": [0,1], "duration": 300, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'
                    >
                        <h3 className="fw-700 text-dark-gray mb-20px ls-minus-2px">{heading}</h3>
                        <h2 className="fw-400 ls-0px mb-0" dangerouslySetInnerHTML={{__html: description}} />
                    </div>
                </div>
            </div>
        </section>
    )
}
